<script setup lang="ts">
import { Activity } from "lucide-vue-next";
import type { ProductResponse } from "../../../responses/ProductResponse.ts";
import { useProductStore } from "../../stores/product.ts";

interface Props {
    product: ProductResponse;
}

const props = defineProps<Props>();
const productStore = useProductStore();
</script>

<template>
    <div class="w-full">
        <div v-if="product.variants?.length > 1" v-for="variant in product.variants" class="flex flex-col gap-2 ">
            <div @click="productStore.setSelectedVariant(variant)" :class="{ underline: productStore.selectedVariant?.id === variant.id }" class="flex flex-row gap-1 cursor-pointer items-center">
                <Activity class="w-4 h-4" />
                <span v-text="variant.ean"></span>
            </div>
        </div>
    </div>
</template>
